'use strict';

module.exports = {
    ...require('./global'),
    ...require('./account'),
    ...require('./cart'),
    ...require('./newsletter'),
    ...require('./wishlist'),
    ...require('./promotionAndInfo'),
    ...require('./findYourStore'),
    ...require('./product'),
    ...require('./scalaPay'),
    ...require('./afterpay'),
    ...require('./refund')
};
